export default __webpack_public_path__ + "static/016-2d14a99ab1629babfa00e6a92f64a3f9.jpg";